import { createFeatureSelector, createSelector } from '@ngrx/store';
import { annotationsFeatureKey, State } from '../reducers/annotations.reducer';

export const selectAnnotationsState =
  createFeatureSelector<State>(annotationsFeatureKey);

export const selectAnnotations = createSelector(
  selectAnnotationsState,
  (state: State) => state.annotations
);

export const selectIsLoading = createSelector(
  selectAnnotationsState,
  (state: State) => state.loading
);

export const selectIsLoaded = createSelector(
  selectAnnotationsState,
  (state: State) => state.loaded
);

export const selectAnnotation = (category: string, id: string) =>
  createSelector(
    selectAnnotations,
    (annotations) => annotations?.[category]?.[id] ?? null
  );
